import { v4 } from 'uuid';
import { state } from '../state';
import React from 'react';

const modals = state.select('modals');

export interface ModalProps {
  id?: string;
  close: (...args: any) => any;
  reject: () => void;
}

export class ModalsService {
  static async createModal<
    T extends ModalProps,
    CloseParams = Parameters<T['close']>[0],
  >(type: React.FC<T>, props?: Omit<T, 'id' | 'close' | 'reject'>) {
    const id = v4();
    return new Promise<CloseParams>((resolve, reject) => {
      try {
        modals.push({
          id,
          type,
          props: Object.assign({}, props, {
            id,
            close(result: CloseParams) {
              resolve(result);
              ModalsService.removeModal(id);
            },
            reject() {
              reject();
              ModalsService.removeModal(id);
            },
          }),
        });
      } catch (e) {
        reject(e);
      }
    });
  }

  private static removeModal(id: string) {
    // Baobab throws "the dynamic path of the cursor cannot be solved" if no
    // modal with this id is in state — typically because the close/reject
    // handler ran twice (double-click, focus + escape, parent unmount during
    // an inflight close). Resolve the cursor first and only unset when the
    // modal is actually still there.
    //
    // The dynamic cursor must also be released — Baobab keeps a reference
    // for path solving, and leaving it attached on every modal close
    // accumulates over a session.
    const cursor = modals.select({ id });
    try {
      if (cursor.exists()) {
        cursor.unset();
      }
    } finally {
      cursor.release();
    }
  }
}
